var emotionCSS = require("@emotion/css").default;

var _require = require("@pwops/core"),
    pwop = _require.pwop;

exports.css = function (obj) {
  return emotionCSS(pwop(obj));
};